module.exports = __webpack_public_path__ + "static/media/Github_white.1ab0f323.svg";